import { createAction } from "@ngrx/store";
import { ModulesWithSubmodulesModel } from "../models/module.model";

export const USER_MENU = createAction(
  "USER_MENU",
  (menu: ModulesWithSubmodulesModel[]) => ({
    menu,
  }),
);
